<oe-flat-widget [icon]="{name: 'oe-consumption', color: 'normal'}" [title]="'GENERAL.SELF_CONSUMPTION' | translate"
    [modalComponent]="modalComponent">
    <oe-flat-widget-percentagebar [value]="this.calculatedSelfConsumption"></oe-flat-widget-percentagebar>
</oe-flat-widget>